import {
  FETCH_SHARING_EMAILS_ASYNC,
  SET_SHARING_EMAILS_PAGE,
  SHARE_EMAILS_CHANGE,
  SHARE_MESSAGE_CHANGE,
  SHARE_RESET,
  SHARE_RESET_ERROR,
  SHARE_SUBMIT_ASYNC,
} from './constants'

export const shareSubmit = (shareType, customData) => ({
  type: SHARE_SUBMIT_ASYNC.INITIATE,
  payload: { shareType, customData },
})
export const shareSubmitSuccess = (data) => ({
  type: SHARE_SUBMIT_ASYNC.SUCCESS,
  payload: { data },
})
export const shareSubmitError = (error) => ({
  type: SHARE_SUBMIT_ASYNC.ERROR,
  error,
})

export const getSharingEmails = ({ search, includeMspUsers, page, pageSize }) => ({
  type: FETCH_SHARING_EMAILS_ASYNC.INITIATE,
  payload: { search, page, pageSize, includeMspUsers },
})
export const getSharingEmailsSuccess = (data) => ({
  type: FETCH_SHARING_EMAILS_ASYNC.SUCCESS,
  payload: { data },
})
export const getSharingEmailsError = (error) => ({
  type: FETCH_SHARING_EMAILS_ASYNC.ERROR,
  error,
})
export const setSharingEmailsPage = (value) => ({
  type: SET_SHARING_EMAILS_PAGE,
  payload: { value },
})

export const selectedProfilesPropertiesOnChange = (data) => ({
  type: SHARE_EMAILS_CHANGE,
  payload: { data },
})
export const messageOnChange = (value) => ({
  type: SHARE_MESSAGE_CHANGE,
  payload: { value },
})

export const shareReset = () => ({ type: SHARE_RESET })
export const shareResetError = () => ({ type: SHARE_RESET_ERROR })

export default {
  // to props
  shareReset,
  shareSubmit,
  selectedProfilesPropertiesOnChange,
  messageOnChange,
  getSharingEmails,
  setSharingEmailsPage,
}
